import favoriteEntitiesStore from "../../core/states/favorite-entities.store";
import FavoriteItemElement from "./favorite-item.component";
var FavoriteListComponent = /** @class */ (function () {
    function FavoriteListComponent(elementId) {
        this.favoriteListElement = document.querySelector(elementId);
        if (this.favoriteListElement) {
            this.initiateFavoritesDisplay();
        }
    }
    FavoriteListComponent.prototype.initiateFavoritesDisplay = function () {
        var _this = this;
        favoriteEntitiesStore.subscribe(function (entities) {
            var _a;
            var children = [];
            entities.forEach(function (favorite) {
                var favoriteItem = new FavoriteItemElement(favorite);
                // this.favoriteListElement.appendChild(favoriteItem.getElement());
                children.push(favoriteItem.getElement());
            });
            (_a = _this.favoriteListElement).replaceChildren.apply(_a, children);
        });
    };
    return FavoriteListComponent;
}());
export default FavoriteListComponent;
